// extracted by mini-css-extract-plugin
module.exports = {"layout":"OverviewPage_layout__fhAff","bottom":"OverviewPage_bottom__17Uyr"};